import isEmpty from './isEmpty.js'
//-------------
// has temp id
//-------------
export default function hasTempId(id) {
  if (!isEmpty(id) && id.toString().startsWith('TMP')) {
    return true
  }
  return false
}
